// The pages in this folder serve two approval flows that share one backend table:
// "ເພີ່ມລູກຄ້າທຸລະກິດ" (new company) and "ປິດສາຍບ້ານເປີດທຸລະກິດ" (close a household
// customer, open a commercial one). The route's meta.formKind picks the flow.
const KINDS = {
  submission: {
    api: 'company-submission',
    listRoute: 'CompanySubmission',
    createRoute: 'CreateCompanySubmission',
    editRoute: 'EditCompanySubmission',
    listTitle: 'ລູກຄ້າທຸລະກິດທີ່ເພີ່ມ (ລໍຖ້າອະນຸມັດ)',
    createButton: 'ເພີ່ມລູກຄ້າທຸລະກິດ',
    createTitle: 'ເພີ່ມລູກຄ້າທຸລະກິດ (ລໍຖ້າອະນຸມັດ)',
    approvalTitle: 'ອະນຸມັດລູກຄ້າທຸລະກິດໃໝ່',
    historyTitle: 'ປະຫວັດການອະນຸມັດລູກຄ້າທຸລະກິດ',
    isConversion: false,
  },
  convert: {
    api: 'home-conversion',
    listRoute: 'HomeConversion',
    createRoute: 'CreateHomeConversion',
    editRoute: 'EditHomeConversion',
    listTitle: 'ປິດສາຍບ້ານເປີດທຸລະກິດ (ລໍຖ້າອະນຸມັດ)',
    createButton: 'ປິດສາຍບ້ານ ເປີດທຸລະກິດ',
    createTitle: 'ປິດລູກຄ້າສາຍບ້ານ ແລະ ເປີດເປັນລູກຄ້າທຸລະກິດ (ລໍຖ້າອະນຸມັດ)',
    approvalTitle: 'ອະນຸມັດ ປິດສາຍບ້ານເປີດທຸລະກິດ',
    historyTitle: 'ປະຫວັດ ປິດສາຍບ້ານເປີດທຸລະກິດ',
    isConversion: true,
  },
};

export function submissionKind(route) {
  return route.meta.formKind === 'convert' ? KINDS.convert : KINDS.submission;
}

/** "CUS_123 · ທ ຄຳ ແສງ" for a household customer from the API. */
export function homeLabel(home) {
  if (!home) return '';
  const name = [home.name, home.surname].filter(Boolean).join(' ');
  return name ? `CUS_${home.id} · ${name}` : `CUS_${home.id}`;
}
